import React, { Component } from 'react';
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";

import Business from "../models/business";

// Block imports
import Helpers from "../Utils/Helpers";
import Registry from "../Utils/Registry";
import EnterpriseCoworkers from "../components/Enterprise/Coworkers";
import EnterprisePayments from "../components/Enterprise/Payments";
import EnterpriseInformation from "../components/Enterprise/Information";
import EnterpriseInvoices from "../components/Enterprise/Invoices";
import EnterpriseInvoicesV2 from '../components/Enterprise/InvoicesV2';


class Enterprise extends Component {

    constructor(props){
        super(props);

        this.toggleTab = this.toggleTab.bind(this);

        this.keys_links = {
            info: "info",
            paiement: "payment",
            collaborateurs: "coworkers",
            factures: "invoices",
            Factures2: "invoices-v2"
        };

        this.keys_title = {
            info: "Informations générales",
            paiement: "Moyens de paiement",
            collaborateurs: "Collaborateurs",
            factures: "Factures",
            Factures2: "Factures V2 (Beta)"
        };

        this.keys_components = {
            info: <EnterpriseInformation />,
            paiement: <EnterprisePayments />,
            collaborateurs: <EnterpriseCoworkers />,
            factures: <EnterpriseInvoices orderStatus="done" />,
            Factures2: <EnterpriseInvoicesV2 orderStatus="done" />
        }

        let default_key = "info";
        if(this.props.match.params.subkey && this.keys_links[this.props.match.params.subkey])
            default_key = this.keys_links[this.props.match.params.subkey];

        this.business = new Business();

        this.state = {
            openedTab: default_key,
            businessId: null
        };
    }

    componentDidMount(){
        this.user = Registry.observe(this, "user", user => {
            this.user = user;
            this.loadData();
        });
        if(this.user)
            this.loadData();
    }

    toggleTab(key){
        if(this.keys_links[key]){
            Helpers.goTo("/entreprise/" + key);
            this.setState({openedTab: this.keys_links[key]}, () => {
                Helpers.scrollOnClick(this.keys_links[key]);
            });
        }
    }

    loadData(){
        if(this.user){
            this.business.load(this.user.business_id, () => this.setState({
                businessId: this.business.id
            }));
        }
    }

    render() {
        return (
            <div className="no-padding">
                <Nav tabs className="header-tabs" id="container">
                    {
                        Object.keys(this.keys_links).map(k => <NavItem key={`nav-${k}`} id={this.keys_links[k]}>
                            <NavLink
                                className={ this.state.openedTab === this.keys_links[k] ? "active" : "" }
                                onClick={() => this.toggleTab(k)}
                            >
                                { this.keys_title[k] || "" }
                            </NavLink>
                        </NavItem>)
                    }
                </Nav>

                <TabContent className="header-tabs pad-tab-content" activeTab={this.state.openedTab}>
                    {
                        Object.keys(this.keys_links).map(k => <TabPane key={`pane-${k}`} tabId={this.keys_links[k]}>
                            { this.keys_components[k] }
                        </TabPane>)
                    }
                </TabContent>
            </div>
        )
    }

}

export default Enterprise;



// WEBPACK FOOTER //
// ./src/views/Enterprise.js